import React from 'react'
import Navbarimg from '../assets/images/Burleson - City - Rough - White.png'
import { Link } from "react-router-dom"
import { useLocation } from 'react-router-dom';

export default function Navbar() {

    const location = useLocation();

    const { pathname } = location;

    const splitLocation = pathname.split("/");

    console.log(splitLocation)

    return (
        <div>

            <nav className="navbar navbar-expand-md navbar-dark fixed-top" style={{backgroundColor: "#511e20", fontWeight:"bold"}}>
                <a className="navbar-brand ms-3" href="https://www.burlesontx.com/" target="_blank"><img src={Navbarimg} style={{maxHeight:"40px"}}/></a>
                <button className="navbar-toggler mx-1" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span> </button>
                <div className="collapse navbar-collapse" id="navbarCollapse">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "" ? "active" : "")} to="/">Home</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "CoreValues" ? "active" : "")} to="/CoreValues">Core Values</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "FutureLandUse" ? "active" : "")} to="/FutureLandUse">Future Land Use</Link></li>
                        <li className="nav-item"> <Link className="nav-link" id={(splitLocation[1] == "DraftPlanDocs" ? "active" : "")} to="/DraftPlanDocs">Draft Plan Documents</Link></li>
                        <li className="nav-item active"> <Link className="nav-link" id={(splitLocation[1] == "GetInvolved" ? "active" : "")} to="/GetInvolved">Get Involved!</Link></li>
                    </ul>
                </div>
            </nav>

        </div>
    )
}
